import type { BrushOptions } from './types'

/** Current document schema version. */
export const DOC_VERSION = 1 as const

/** Default logical canvas for a new free-draw document (§2). */
export const DEFAULT_CANVAS = { width: 1920, height: 1080 } as const

/** Default background for a new document (§3). */
export const DEFAULT_BACKGROUND = '#ffffff'

/**
 * The caps the editor enforces itself, each equal to the Go validator's
 * (`server/internal/document/validate.go`). The other caps are the server's alone.
 */
export const LIMITS = {
    maxCanvasDimension: 8192,
    maxLayers: 64,
    maxNameLen: 64
} as const

/**
 * Pinned perfect-freehand version — part of the render contract (§5.3, §9).
 * Stamped into `meta.freehandVersion`; the editor preview and the server render
 * worker MUST resolve this exact version from the lockfile, or their outlines
 * diverge.
 */
export const FREEHAND_VERSION = '1.2.3'

/** Editor/tool brush defaults (§5.3). Identical everywhere — no dev/prod drift. */
export const BRUSH_DEFAULTS: BrushOptions = {
    size: 16,
    thinning: 0.5,
    smoothing: 0.5,
    streamline: 0.5,
    simulatePressure: true,
    taperStart: 0,
    taperEnd: 0
}

/** Write-precision (§2): geometry rounds to 2 dp, freehand pressure to 3 dp. */
export const COORD_DP = 2
export const PRESSURE_DP = 3
